import React from 'react';
import { useFetchSpotifyAccount } from 'client/hooks/spotifyConnect/useFetchSpotifyAccount';
import {
  SPOTIFY_OAUTH_SUCCESS_MESSAGE,
  initiateOAuth,
  SPOTIFY_OAUTH_FAIL_MESSAGE,
} from './spotifyConnectUtils';
import { SpotifyConnectSuccessModal } from './SpotifyConnectSuccessModal';
import { SpotifyConnectInitialModal } from './SpotifyConnectInitialModal';
import { SpotifyConnectErrorModal } from './SpotifyConnectErrorModal';

type SpotifyConnectModalProps = {
  onComplete: (state: SpotifyConnectState) => void;
};

export type SpotifyConnectState =
  | 'initial'
  | 'success'
  | 'failure'
  | 'cancelled';

export const SpotifyConnectModal = ({
  onComplete,
}: SpotifyConnectModalProps) => {
  const [
    spotifyConnectState,
    setSpotifyConnectState,
  ] = React.useState<SpotifyConnectState>('initial');
  const {
    data: accountInfo,
    status: spotifyAccountStatus,
    refetch,
  } = useFetchSpotifyAccount({
    enabled: false,
  });

  const onConnectedToSpotify = (e: MessageEvent) => {
    if (e.data === SPOTIFY_OAUTH_SUCCESS_MESSAGE) {
      refetch();
      // TODO: handle failure and error response codes
      setSpotifyConnectState('success');
    } else if (e.data === SPOTIFY_OAUTH_FAIL_MESSAGE) {
      setSpotifyConnectState('failure');
    }
  };

  switch (spotifyConnectState) {
    case 'initial':
      return (
        <SpotifyConnectInitialModal
          onConnectSpotify={() => {
            initiateOAuth(onConnectedToSpotify);
          }}
          onClose={() => onComplete('cancelled')}
        />
      );
    case 'success':
      return (
        <SpotifyConnectSuccessModal
          accountInfo={accountInfo}
          onContinue={() => onComplete('success')}
          onClose={() => onComplete('success')}
          isLoading={spotifyAccountStatus === 'loading'}
        />
      );
    case 'failure':
      return (
        <SpotifyConnectErrorModal
          onClose={() => onComplete('cancelled')}
          onRetry={() => setSpotifyConnectState('initial')}
        />
      );
    default:
      return null; // should never happen
  }
};
